import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deleteCookie } from 'utils/bom-dom-manipulation/cookies';
import LS from 'utils/bom-dom-manipulation/local-storage';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { loginState } from 'utils/sportsbook/api-post-message-sender';
import { logout } from 'services/authentication';
import { FavoritePersonalization } from 'services/favorite-personalization';
import { addQueryInString, getSavedLocation } from 'components/QueryRoute';
import { setClientGamingStateInfo, setOneSignalSubId } from 'store/actions';
import { setUserNotifications } from 'store/actions/sport-data';
import { removeUserData, setUserOptIns } from 'store/actions/user-data';
import { getFirebaseToken, getOneSignalSubId } from 'store/selectors/app-data';

export const useAccountLogout = (params?: {
  source: number;
}): ((shouldRedirect?: boolean) => void) => {
  const { clearDataFromStorage } = FavoritePersonalization();

  const dispatch = useDispatch();
  const history = useHistory();

  const firebaseToken = useSelector(getFirebaseToken);
  const oneSignalSubId = useSelector(getOneSignalSubId);

  const removeUser = (shouldRedirect?: boolean) => {
    shouldRedirect &&
      history.push(
        addQueryInString(getSavedLocation(), {
          accounts: undefined,
          login: undefined,
          register: undefined
        })
      );
    dispatch(removeUserData());
    dispatch(setUserOptIns(null));
    dispatch(setUserNotifications({}));
    dispatch(setClientGamingStateInfo(null));

    LS.removeItem(storageKeyName('account', 'LOGIN_LIMIT_START_TIME'));
    LS.removeItem(storageKeyName('account', 'LOGIN_LIMIT_POPUP_START_TIME'));
    LS.removeItem(storageKeyName('account', 'IS_LOGOUT'));
    deleteCookie('sbuser');
    deleteCookie('loginCredentials');
    LS.removeItem(storageKeyName('account', 'ADDITIONAL_INFO_POPUP'));
    LS.removeItem(storageKeyName('account', 'PARENT_ACCOUNT_CURRENCY'));

    if (SpringConfigs.IFRAME_SPORTSBOOK) {
      loginState('loggedOut');
    }

    if (SpringConfigs.WRAPPER_APP && window.median?.auth) {
      window.median.auth.delete();
    }

    if (
      SpringConfigs.USER_PERSONALIZATION_ENABLED &&
      !SpringConfigs.MOCKED_DATA
    ) {
      clearDataFromStorage();
    }

    if (window.refreshWhenLoggedIn) {
      window.mustRefreshForSessionVisibility = true;
      window.location.reload();
    }
  };

  return (shouldRedirect?: boolean) => {
    const additionalParams: {
      fcm_token?: string;
      subscription_id?: string;
    } = {};

    if (firebaseToken) {
      additionalParams.fcm_token = firebaseToken;
    }

    if (oneSignalSubId) {
      additionalParams.subscription_id = oneSignalSubId;
      dispatch(setOneSignalSubId(''));
    }

    logout(() => removeUser(shouldRedirect), {
      ...additionalParams,
      ...params
    });
  };
};
